import $ from 'jquery';

function updateSlider(input: HTMLInputElement): void {
  const $input = $(input);
  const $output = $input.next() as JQuery<HTMLElement>;
  const min = parseFloat($input.attr('min') || '0');
  const max = parseFloat($input.attr('max') || '100');
  const value = parseFloat($input.val() as string);

  requestAnimationFrame(() => {
    $output.attr('data-value', Math.round(value).toString());

    const percent = (value - min) / (max - min);

    const inputWidth = $input.outerWidth() || 0;
    const computedStyle = window.getComputedStyle(input);
    const outputProperty = computedStyle.getPropertyValue('--output');
    const fontSize = parseFloat(computedStyle.fontSize);
    const thumbWidth = parseFloat(outputProperty) * fontSize;
    const outputWidth = $output.outerWidth() || 0;

    const position = percent * (inputWidth - thumbWidth) + (thumbWidth / 2) - (outputWidth / 2);
    $output.css('left', `${position}px`);
  });
}

$('input[type="range"]').each((_index: number, input: HTMLElement) => {
  const rangeInput = input as HTMLInputElement;
  updateSlider(rangeInput);

  $(rangeInput).on('input', () => updateSlider(rangeInput));

  $(window).on('resize', () => updateSlider(rangeInput));
});
